import type { ReactElement } from 'react';
import type { IconRenderProps } from '../types';

export function BurgerIcon({
	width = 20,
	height = 20,
	color = 'currentColor',
	style,
	...rest
}: IconRenderProps): ReactElement {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 20 20"
			fill="none"
			aria-hidden="true"
			style={{ display: 'block', ...style }}
			{...rest}
		>
			<rect
				className="burger-icon__line burger-icon__line--bottom"
				width="20"
				height="2.40003"
				rx="1.20002"
				y="17.6002"
				fill={color}
			/>
			<rect
				className="burger-icon__line burger-icon__line--middle"
				width="20"
				height="2.40003"
				rx="1.20002"
				y="8.79967"
				fill={color}
			/>
			<rect
				className="burger-icon__line burger-icon__line--top"
				width="20"
				height="2.40003"
				rx="1.20002"
				y="0"
				fill={color}
			/>
		</svg>
	);
}
